import { FileDropzone, FileItem } from "../ui/FileDropzone";
import { FormField, FormItem } from "../ui/form";
import { CloudUpload } from "lucide-react";
import { TranslatedFormMessage } from "../ui/custom-form";
import { t } from "i18next";
import { FormFieldProps } from "./types";
import { Thumbnail } from "../ui/tumbnail";

export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

const DragAndDropLoadImage = ({
  fileItemValidationMark = false,
  control,
  config,
  className,
  content
}: FormFieldProps) => {
  return (
    <FormField
      control={control}
      name={config.name}
      render={({ field, fieldState }) => (
        <>
          {field.value == undefined || fieldState.error ? (
            <FormItem>
              <FileDropzone
                multiple={false}
                onDrop={(f: File[]) => {
                  field.onChange(f[0]);
                }}
                className={className}
                children={() => (
                  <div className="flex flex-col items-center justify-center gap-6">
                    <Thumbnail>
                      <CloudUpload className="text-gray-700 size-6" />
                    </Thumbnail>
                    <span className="text-gray-600 text-sm">
                      <span className="text-blue-700 font-semibold">
                        {t("loadImage.clickCta")}
                      </span>{" "}
                      {t("loadImage.dragCta")}
                    </span>
                    <span className="text-gray-600 text-xs">
                      {content}
                    </span>
                  </div>
                )}
              />
              <TranslatedFormMessage />
            </FormItem>
          ) : (
            <FileItem
              file={field.value}
              image={<img src={URL.createObjectURL(field.value)} alt="file" />}
              onDelete={() => field.onChange(undefined)}
              className={className}
              validationMark={fileItemValidationMark}
            />
          )}
        </>
      )}
    />
  );
};

export default DragAndDropLoadImage;
